export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
}

export interface ConfigurationDto {
  id: string;
  displayName: string;
  company: string;
  documentService: string;
  packageName: string;
  packageVersion: string;
  template: string;
  dialogDesign: string;
  customer: string;
  catalog: string;
  style: StyleDto;
  icon: string;
  securityLevel: SecurityLevel;
  primaryColor: string;
  companyUrl: string;
  replaceIconsInCatalog: boolean;
  dataCaptureTemplateTitle: string;
  dataCaptureTemplateSelectionTitle: string;
  enabled: boolean;
  buttons: Button[];
  simpleSecurityDefinition: SimpleSecurityDefinitionAdminDto | null;
  entraSecurity: EntraSecurityAdminDto | null;
}

export interface ConfigurationDisplayDto {
  id: string;
  displayName: string;
}

export interface SimpleSecurityDefinition{
  fields: string[];
}

export interface Button {
  id: string;
  location: ButtonLocation;
  function: ButtonFunction;
  workflowService: string;
  workflowPlanId: number;
  text: string;
  displayOrder: number;
  downloadToTemplate: boolean;
  buttonMetadata: ButtonMetadata[]
}
export interface ButtonMetadata {
  id: string;
  metadata: Metadata;
  fieldName: string;
}

export enum ButtonFunction {
  Submit = "Submit",
  Reset = "Reset",
  Other = "Other"
}

export enum ButtonLocation {
  Header = "Header",
  Footer = "Footer",
  DataCapture = "DataCapture"
}

export enum SecurityLevel {
  None = "None",
  Simple = "Simple",
  Entra = "Entra"
}

export enum Metadata{
   Design = "Design",
   DocumentService = "DocumentService",
   PackageName = "PackageName",
   PackageVersion = "PackageVersion",
   Template = "Template",
   //TemplateListXml = "TemplateListXml",
   //User = "User",
   FillableXml = "FillableXml",
   FilledXml = "FilledXml",
   FullXml = "FullXml",
  VisibleXml = "VisibleXml"
}

export interface StyleDto {
  primaryColor?: string;
  secondaryColor?: string;
  backgroundColor?: string;
  titleDisplay?: string;
  titleSize?: string;
  titleFont?: string;
  subTitleSize?: string;
  subTitleFont?: string;
  logoDisplay?: string;
  logoSize?: string;
  loginPageLogoSize?: string;
  logoOrder?: string;
}

export interface SimpleSecurityDefinitionAdminDto {
  id: string;
  name?: string;
  surname?: string;
  email?: string;
  phoneNumber?: string;
  additionalOne?: string;
  additionalTwo?: string;
  users?: SimpleSecurityUserAdminDto[];
}

export interface SimpleSecurityUserAdminDto {
  id: string | null;
  name?: string;
  surname?: string;
  email?: string;
  phoneNumber?: string;
  additionalOne?: string;
  additionalTwo?: string;
}
export interface EntraSecurityAdminDto {
  id: string | null;
  name: string;
  tenantId: string;
  clientId: string;
}